export default __webpack_public_path__ + "static/typography-image-x-f7d6b233b318289d9f9bd65b30c24340f71410ba55c3ebc04d72e169bbae9b8d.png";